import { isRenderingOnServer } from "~/helpers/projectConstant";
import type { CampaignProps } from "~/types/Campaign";

export const getCampaignCode = (): string => 
  isRenderingOnServer() ? '' : new URLSearchParams(window.location.search).get('c') || '';

const BrandingBits = {
    Undefined: 0,
    Style_PoweredBy: 8,
    Style_VerwijderHeaderFooter: 16,
    Functional_MailUnbranded: 32,
} as const;

const hasBrandingBit = (campaign: CampaignProps | undefined, bit: number): boolean =>
  Boolean((campaign?.brandingBits ?? 0) & bit);

export const hasHiddenHeaderFooter = (campaign?: CampaignProps) =>
  hasBrandingBit(campaign, BrandingBits.Style_VerwijderHeaderFooter);

export const hasPoweredByLogo = (campaign?: CampaignProps) =>
  hasBrandingBit(campaign, BrandingBits.Style_PoweredBy);